(function () {
  document.querySelectorAll('[data-buybox-root]').forEach(function (root) {
    var jsonEl = root.parentElement.querySelector('[data-buybox-json]');
    var data = JSON.parse(jsonEl.textContent);

    var idInput = root.querySelector('[data-variant-id]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var titleEl = root.querySelector('[data-product-title]');
    var colorLabel = root.querySelector('[data-color-label]');
    var priceTotal = root.querySelector('[data-price-total]');
    var pricePer = root.querySelector('[data-price-per]');
    var imgWrap = root.querySelector('[data-buy-img]');
    var thumbRow = root.querySelector('[data-thumb-row]');

    var bundleQty = parseInt(root.dataset.bundleQty || '2', 10);
    var variantIds = [root.dataset.p1Id, root.dataset.p2Id, root.dataset.p3Id];

    var state = { color: 0, qty: 'single' };

    function money(cents) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
    }

    function renderImages(colorIdx) {
      var d = data[colorIdx];
      if (!d) return;
      imgWrap.innerHTML = d.images.map(function (src, i) {
        return '<img src="' + src + '" class="buy-media' + (i === 0 ? ' is-active' : '') + '" data-media-index="' + i + '" alt="">';
      }).join('');
      thumbRow.innerHTML = d.thumbs.map(function (src, i) {
        return '<button type="button" class="thumb' + (i === 0 ? ' is-active' : '') + '" data-thumb data-media-index="' + i + '"><img src="' + src + '" alt=""></button>';
      }).join('');
      bindThumbs();
    }

    function bindThumbs() {
      thumbRow.querySelectorAll('[data-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = btn.dataset.mediaIndex;
          thumbRow.querySelectorAll('.thumb').forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
          imgWrap.querySelectorAll('.buy-media').forEach(function (img) {
            img.classList.toggle('is-active', img.dataset.mediaIndex === idx);
          });
        });
      });
    }

    function renderPrice() {
      var d = data[state.color];
      if (state.qty === 'single') {
        priceTotal.textContent = money(d.price);
        pricePer.textContent = '';
        idInput.value = variantIds[state.color];
        qtyInput.value = 1;
      } else {
        var bundlePriceEl = root.querySelector('[data-qty-pick="bundle"] .qty-price');
        priceTotal.textContent = bundlePriceEl ? bundlePriceEl.textContent : money(d.price * bundleQty);
        pricePer.textContent = '';
        idInput.value = variantIds[state.color];
        qtyInput.value = bundleQty;
      }
    }

    function updateSingleCardPrice() {
      var d = data[state.color];
      var sub = root.querySelector('[data-single-sub]');
      var price = root.querySelector('[data-single-price]');
      if (price) price.textContent = money(d.price);
    }

    root.querySelectorAll('[data-color-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.color = parseInt(btn.dataset.colorPick, 10);
        root.querySelectorAll('.swatch').forEach(function (s) { s.classList.remove('active'); });
        btn.classList.add('active');
        var badgeEl = root.parentElement.querySelector('[data-badge-label]');
if (badgeEl) badgeEl.textContent = data[state.color].badge;
        colorLabel.textContent = btn.getAttribute('aria-label');
        renderImages(state.color);
        updateSingleCardPrice();
        renderPrice();
      });
    });

    root.querySelectorAll('[data-qty-pick]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.qty = btn.dataset.qtyPick;
        root.querySelectorAll('.qty-card').forEach(function (c) { c.classList.remove('active'); });
        btn.classList.add('active');
        renderPrice();
      });
    });

    bindThumbs();
    updateSingleCardPrice();
    renderPrice();
  });
})();